import type { ApiResponse, Pagination } from "@/types";

import { BaseApi } from "../base.api";

export type TeacherRequestStatus = "pending" | "approved" | "rejected";

export interface TeacherRequest {
  id: number;
  userId: number;
  specialization: string;
  experience: string;
  /** "O'zi haqida" bo'limi — boy matn (HTML). */
  bio: string;
  achievements: string | null;
  /** Qisqa muddatli imzolangan yuklab olish havolalari (o'qishda hosil qilinadi). */
  diplomaUrl?: string;
  resumeUrl?: string;
  status: TeacherRequestStatus;
  reviewedById: number | null;
  reviewedAt: string | null;
  rejectionReason: string | null;
  createdAt: string;
  updatedAt: string;
  /** Ariza beruvchi (moderator o'qiganda qo'shib beriladi). */
  user?: {
    id: number;
    firstName: string;
    lastName: string;
    email: string;
    avatarUrl: string | null;
  };
}

export interface TeacherRequestFilter {
  page?: number;
  limit?: number;
  status?: TeacherRequestStatus;
  order?: "ASC" | "DESC";
}

/** Arizalar API — backend'dagi `TeacherRequestsController` ning ko'zgusi. */
export class TeacherRequestsApi extends BaseApi {
  private readonly baseUrl: string = "/teacher-requests";

  /** O'quvchi: o'qituvchilikka ariza (multipart: maydonlar + diplom [+rezyume]). */
  apply(data: FormData) {
    return this.request.post<TeacherRequest, ApiResponse<TeacherRequest>>(this.baseUrl, data);
  }

  /** O'quvchi: o'zining arizalari. */
  getMine() {
    return this.request.get<TeacherRequest[], ApiResponse<TeacherRequest[]>>(`${this.baseUrl}/me`);
  }

  /** Moderator/admin: ko'rib chiqish navbati (sahifalangan). */
  list(filter: TeacherRequestFilter) {
    return this.request.get<TeacherRequest[], Pagination<TeacherRequest>>(this.baseUrl, {
      params: filter,
    });
  }

  /** Moderator/admin: bitta ariza. */
  getOne(id: number) {
    return this.request.get<TeacherRequest, ApiResponse<TeacherRequest>>(`${this.baseUrl}/${id}`);
  }

  /** Moderator/admin: tasdiqlaydi — ariza beruvchi o'qituvchi bo'ladi. */
  approve(id: number) {
    return this.request.patch<TeacherRequest, ApiResponse<TeacherRequest>>(
      `${this.baseUrl}/${id}/approve`,
      {},
    );
  }

  /** Moderator/admin: sabab bilan rad etadi. */
  reject(id: number, reason: string) {
    return this.request.patch<TeacherRequest, ApiResponse<TeacherRequest>>(
      `${this.baseUrl}/${id}/reject`,
      { reason },
    );
  }
}

export const teacherRequestsApi = new TeacherRequestsApi();
